
<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>
<div class="page-top-divider"></div>

<!-- HERO SECTION -->
<section class="hero">
  <div class="container">
    <div class="hero-grid">

      <!-- LEFT -->
      <div class="hero-left">
        <h1>Walgreens Immunization Voucher Program</h1>

        <p>
          <strong>What is the Walgreens Voucher Program?</strong><br>
          The Walgreens Immunization Voucher Program is a convenient health benefit offered by employers and
          organizations.
          It provides eligible participants with vouchers to receive recommended immunizations at any Walgreens or Duane
          Reade location nationwide.
          <br><br>
          This program helps organizations promote healthy behaviors and reduce preventable illnesses among employees.
          By offering immunization vouchers, employers make it easier and more affordable for their teams to stay
          healthy—saving on medical costs and supporting overall wellness.
        </p>

        <button class="cta-btn" routerLink="/register">
          Sign up to get started
        </button>
      </div>

      <!-- RIGHT -->
      <div class="hero-right">
        <img src="assets/Vaccine_image.jpg" alt="Vaccination" />
      </div>

    </div>
  </div>
</section>

<!-- WHY CHOOSE SECTION -->
<section class="why">
  <div class="container">
    <h2>Why Choose Walgreens for Immunizations?</h2>
    
    <ul class="why-list">
      <li>
        <strong>Nationwide Access:</strong>
        Over 8,000 Walgreens locations across the U.S. make it easy for employees to get vaccinated wherever they are.
      </li>
      <li>
        <strong>Trusted Expertise:</strong>
        Our licensed pharmacists provide a full range of recommended vaccines for adults, seniors, and adolescents.
      </li>
      <li>
        <strong>Personalized Care:</strong>
        Pharmacists can make tailored vaccine recommendations based on individual health needs.
      </li>
      <li>
        <strong>Convenience:</strong>
        Schedule an appointment online or simply walk in—no long waits, no hassle.
      </li>
    </ul>    
  </div>
</section>
<!-- WHY IMMUNIZATION MATTERS -->
<section class="immunization">
  <div class="container immunization-row">
    <div class="icon-circle">
      <img src="assets/Injection.png" alt="Injection" />
    </div>

    <div class="immunization-text">
      <h2>Why Immunization Matters</h2>
      <p>
        Vaccines are one of the most effective ways to prevent illness and protect your workforce.
        By participating in the Walgreens Voucher Program, employers help reduce sick days,
        improve productivity, and demonstrate a commitment to employee health and wellness.
      </p>
    </div>
  </div>
</section>

<!-- HOW TO GET STARTED -->
<section class="get-started">
  <div class="container">
    <h2>How to Get Started</h2>

    <ul class="start-list">
      <li>
        <strong>Employers:</strong>
        Create an account using the link below to set up your voucher program.
      </li>
      <li>
        <strong>Employees:</strong>
        Interested in participating? Contact your employer to see if they offer Walgreens immunization vouchers.
      </li>
    </ul>

    <button class="cta-btn" routerLink="/register">
      Create an account
    </button>
  </div>
</section>